import { useEffect } from 'react';

export const Toast = ({ message, type, onClose }) => {
    useEffect(() => {
        if (type === 'success') {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [type, onClose]);

    const isError = type === 'error' || type === 'warning';

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            background: type === 'success' ? '#10b981' : '#ef4444',
            color: '#ffffff',
            padding: '12px 24px',
            borderRadius: '8px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            minWidth: '280px',
            maxWidth: '90%',
            fontWeight: '500',
            animation: 'fadeInDown 0.3s ease-out'
        }}>
            <style dangerouslySetInnerHTML={{__html: `
                @keyframes fadeInDown {
                    from { transform: translate(-50%, -20px); opacity: 0; }
                    to { transform: translate(-50%, 0); opacity: 1; }
                }
            `}} />
            <span style={{ flex: 1, fontSize: '0.95rem' }}>{message}</span>
            {isError && (
                <button 
                    onClick={onClose} 
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#ffffff',
                        cursor: 'pointer',
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        padding: '0 4px',
                        lineHeight: 1,
                        opacity: 0.8
                    }}
                    onMouseOver={e => e.currentTarget.style.opacity = '1'}
                    onMouseOut={e => e.currentTarget.style.opacity = '0.8'}
                >
                    ×
                </button>
            )}
        </div>
    );
};
export default Toast;
